import { Box, Flex } from "@chakra-ui/react";
import PopoverTagColumn from "components/Column/PopoverTagDisplay";
import { TemplateMeetingAttendeeTag } from "components/Tag/ResourceTargetTag/MeetingAttendeeTag";
import { MeetingTemplate, MeetingTemplateId, TemplateMeetingAttendee } from "features/Resources/MeetingTemplate/models";
import { OnboardingJourneyNetworkRelation } from "models/v2/onboardingJourneyNetworkRelation";
import useTargetName from "hooks/useTargetName";
import { PlusNTag } from "components/Tag/PlusNTag";
import ResourceTargetAvatar from "features/Resources/SharedTemplate/Components/ResourceTargetAvatar";
import { useMeetingTemplateDetailQuery } from "../hooks";

export function MeetingTemplateAttendeeAvatar({ attendee }: { attendee: TemplateMeetingAttendee }) {
  const resourceType = attendee?.attendeeType === "CustomEmail" ? "User" : (attendee?.attendeeType || "User");
  let { name, role: derivedRole } = useTargetName({
    resourceId: attendee?.attendeeId || "",
    resourceType: resourceType as "User" | "OnboardingJourneyNetworkRelation" | "MessageServiceChannel",
    options: { enabled: !attendee.emailAddress && !!attendee?.attendee?.id },
  });
  if (attendee.emailAddress) {
    name = attendee.emailAddress;
    derivedRole = undefined;
  }
  return <ResourceTargetAvatar name={name || undefined} roleName={derivedRole} />;
}

export function ListTemplateAttendees({
  meetingTemplate,
}: {
  meetingTemplate: MeetingTemplate;
}) {
  const attendees = meetingTemplate?.attendees ?? [];

  const tagForAttendee = (attendee: TemplateMeetingAttendee) => (
    <TemplateMeetingAttendeeTag
      key={attendee.attendeeId}
      templateAttendee={attendee}
      disabled
      role={attendee.attendeeType === "OnboardingJourneyNetworkRelation" && attendee.attendee ? (attendee.attendee as OnboardingJourneyNetworkRelation).name : undefined}
      isLeader={!!meetingTemplate?.lead && attendee.attendeeType === meetingTemplate.leadType && attendee.attendeeId === meetingTemplate.leadId}
    />
  );

  const maxAvatarCount = 3;

  return (
    <PopoverTagColumn<TemplateMeetingAttendee>
      items={attendees}
      renderTag={tagForAttendee}

      displaySummary={(items: TemplateMeetingAttendee[]) => (
        <Flex align="center" mx="2" flexDirection="row-reverse">
          <PlusNTag
            maxCount={maxAvatarCount}
            items={items}
            ml="-6px"
            size="33px"
          />
          {items.slice(0, maxAvatarCount).reverse().map((attendee) => (
            <Box key={attendee.id} ml="-6px">
              <MeetingTemplateAttendeeAvatar attendee={attendee} />
            </Box>
          ))}
        </Flex>
      )}
      emptyLabel="No Attendees"
      popoverContainerContentProps={{ marginTop: "1" }}
    />
  );
}

export function DisplayTemplateAttendeesColumn({ meetingTemplateId }: { meetingTemplateId: MeetingTemplateId }) {
  const { data: meetingTemplate } = useMeetingTemplateDetailQuery(meetingTemplateId);
  return (
    <Flex align="center" gap="1">
      {meetingTemplate && <ListTemplateAttendees meetingTemplate={meetingTemplate} />}
    </Flex>
  );
}
